import StringHelper from './StringHelper';

export class ArrayHelper {
    public static isValid(value: any) {
        return Array.isArray(value);
    }

    public static toArray<T = any>(value: unknown): T[] {
        return Array.isArray(value) ? value : [];
    }

    public static isHasItems(value: any) {
        return Array.isArray(value) && value.length > 0;
    }

    public static filterValidString(value: any) {
        return Array.isArray(value) && value.filter((item) => StringHelper.isHasValue(item));
    }

    public static shuffle<T>(array: T[]) {
        const result = [...array];
        let currentIndex = result.length;

        // While there remain elements to shuffle...
        while (currentIndex !== 0) {
            // Pick a remaining element...
            const randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [result[currentIndex], result[randomIndex]] = [result[randomIndex], result[currentIndex]];
        }

        return result;
    }

    public static sortByKey<T>(array: T[], key: any) {
        const listAsObject: any = array.reduce((obj: any, currentValue: any) => {
            if (currentValue[key]) {
                obj[currentValue[key]] = currentValue;
            }
            return obj;
        }, {});
        const listOrdered: T[] = Object.values(
            Object.keys(listAsObject)
                .sort()
                .reduce((obj: any, key: any) => {
                    obj[key] = listAsObject[key];
                    return obj;
                }, {}),
        );

        return listOrdered;
    }

    public static unique(arr: any) {
        return this.isHasItems(arr) ? arr.filter((value: any, index: number, array: any[]) => array.indexOf(value) === index) : [];
    }
}
